import { useCallback } from "react";
import useSWRMutation from "swr/mutation";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { Role, RolesAndPermissions } from "./types";

export const useRolesApi = () => {
  const api = useApi();

  const useMyRoles = useCallback(() => {
    const url = "/me/permissions";
    return useSWRMutation<Role[], CustomError, string>(url, (url) => api.get<Role[]>({ url }));
  }, [api]);

  const getAdminRolesAndPermissions = useCallback(() => {
    const url = "/admin/roles_permissions";
    return useSWRMutation<RolesAndPermissions, CustomError, string>(url, (url) =>
      api.get<RolesAndPermissions>({ url })
    );
  }, [api]);

  return { useMyRoles, getAdminRolesAndPermissions };
};
